var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2 24H3.8C1.7 24 0 22.3 0 20.2V5.8C0 3.7 1.7 2 3.8 2H11C11.6 2 12 2.4 12 3C12 3.6 11.6 4 11 4H3.8C2.8 4 2 4.8 2 5.8V20.1C2 21.1 2.8 21.9 3.8 21.9H18.1C19.1 21.9 19.9 21.1 19.9 20.1V13C19.9 12.4 20.3 12 20.9 12C21.5 12 21.9 12.4 21.9 13V20.2C22 22.3 20.3 24 18.2 24Z",
    fill: "#678CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 19C5.7 19 5.5 18.9 5.3 18.7C5.1 18.5 5 18.1 5 17.8L6 12.8C6 12.6 6.1 12.4 6.3 12.3L18.3 0.3C18.7 -0.1 19.3 -0.1 19.7 0.3L23.7 4.3C24.1 4.7 24.1 5.3 23.7 5.7L11.7 17.7C11.6 17.8 11.4 17.9 11.2 18L6.2 19H6ZM7.9 13.5L7.3 16.7L10.5 16.1L21.6 5L19 2.4L7.9 13.5Z",
    fill: "#678CA6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.77cb597fe3145a291aad7f3f1f7fcfb3.svg";
export { ForwardRef as ReactComponent };